export default {
  policyRenewal: 'Policy Renewal',
  policyDetails: 'Policy Details',
  policyRenewalAlertTitle: 'Your Policy is about to expire',
  policyRenewalAlertDescription:
    'Please review your information and proceed to renewal',
  policyAndProfessionInfoDetails: 'Policy & Profession Info',
  declarationsDetails: 'Declarations Details',
  hintQuestion: 'What is required for policy renewal?',
  hintAnswerTitle1: 'Policy and Profession info',
  hintAnswerDescription1:
    'If there are any updates to your policy or profession, please provide the details for renewal.',
  hintAnswerTitle2: 'Declaration Details',
  hintAnswerDescription2:
    'If there are any updates to your declaration, please provide the details for renewal.',
  previousPolicyNumber: 'Previous Policy Number',
  previousInsuranceCompany: 'Name Of Previous Insurance Company',
  previousPolicyExpirationDate: 'Previous Policy Expiration Date',
  previousPolicyRetroactiveDate: 'Retroactive date',
  retroactiveDateRequired: 'Retroactive date is required',
  daysRemaining: '{{days}} day(s) remaining',
  proceedToRenewal: 'Proceed to Renewal',
  confirmRenewal: 'Confirm & continue',
  policyRenewalPopupTitle:
    'Hello {{policyHolderName}}, Your MMP renewal is due on {{expiryDate}}',
  policyRenewalPopupDescription:
    'Review your information in the next page to get renewal quotes.',
  expiryDate: 'Expiry Date',
  policyholderDetails: 'Policyholder Details',
  policyholderId: 'Saudi ID/Iqama Number',
} as const
